module.exports = __webpack_public_path__ + "img/login_bg.e733fec1.svg";